export default (params) => ({
  trigger: {
    name: 'product_plus.select_terms_and_conditions',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'vendor_free_with',
          'nespresso',
          'norton',
        ],
      },
    },
    event: {
      name: 'select_content',
      params: {
        content: 'terms_and_conditions',
      },
    },
    nonInt: false,
  },
});
